
export function Logout() {
    localStorage.clear();
    window.location.href = window.VUE_APP_KEYCLOAK_URL +
      "realms/" + window.VUE_APP_KEYCLOAK_REALM +
      "/protocol/openid-connect/logout";


}